import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SubBoardListItemModel } from '../models/sub-board-list-item-model';
import { SubBoardRequestsCacheService } from './sub-board-requests-cache.service';
import { Observable, of } from 'rxjs';
import { SubBoardListGatewayApiService } from './sub-board-list-api-gateway.service';
import { SubBoardListItemModelCacheEntry } from '../models/sub-board-list-item-model-cache-entry';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SubstitutionRequestModelResolverService  {
    constructor(
        private substitutionRequestsCacheService: SubBoardRequestsCacheService,
        private substitutionRequestApiGateway: SubBoardListGatewayApiService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): SubBoardListItemModelCacheEntry | Observable<SubBoardListItemModelCacheEntry> {
        const queryParams = route.paramMap;
        const substitutionRequestId = queryParams.get('id');
        const clubId = queryParams.get('clubId');
        const model: SubBoardListItemModel = this.substitutionRequestsCacheService.getSubBoardLiteItemModelById(
            substitutionRequestId
        );
        if (model) {
            const cacheEntry: SubBoardListItemModelCacheEntry = {
                model: model,
                loadedFromCache: true
            };
            return of(cacheEntry);
        }

        return this.substitutionRequestApiGateway.getSubBoardListItem(clubId, substitutionRequestId).pipe(
            map((m: SubBoardListItemModel) => {
                const cacheEntry: SubBoardListItemModelCacheEntry = {
                    model: m,
                    loadedFromCache: false
                };

                return cacheEntry;
            })
        );
    }
}
